module.exports = __webpack_public_path__ + "static/img/begin.8726bf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn/begin.png
// module id = lcYU
// module chunks = 1